import React, { useState } from 'react';
import { Box } from '@mui/material';

const ImageViewer = ({ fileUrl }) => {
  const [isZoomed, setIsZoomed] = useState(false);

  // Handle double-click to zoom in/out
  const handleDoubleClick = () => {
    setIsZoomed((prev) => !prev);
  };

  return (
    <Box sx={{ textAlign: 'center', mt: 4 }}>
      {/* Image with zoom */}
      <img
        src={fileUrl}
        alt="Document"
        onDoubleClick={handleDoubleClick}
        style={{
          position: 'relative',
          maxWidth: '100%',
          maxHeight: '500px',
          transition: 'transform 0.3s ease-in-out',
          transform: isZoomed ? 'scale(2)' : 'scale(1)', // Zoom in or out
          cursor: 'pointer', // Change cursor to indicate zoomability
          display: 'block', // Make sure image is displayed as a block element (prevents inline behavior)
          margin: '0 auto', // Center the image horizontally
          zIndex: isZoomed ? 50 : 10,
        }}
      />
    </Box>
  );
};

export default ImageViewer;
